import { combineReducers } from 'redux'
import populateStore from './populateStore'
import incrementXP from './incrementXP'

export default combineReducers({
  incrementXP,
  populateStore
})